<template>
  <div id='apply_for_occupancy'>
    <HeaderVue></HeaderVue>

    <p class="title" id='title'>申请入驻</p>
    <van-form ref='formData' class="formData">

      <div class="apply">
        <p class="item">
          <span><span class="required">*</span>选择分类</span>
          <span class="data" @click="setShowCategoryPicker">{{params.categoryName}}</span>
        </p>
      </div>

      <p class="explain">基本信息</p>
      <div class="apply">
        <p class="item">
          <span><span class="required">*</span>选择三农号图标</span>
          <van-uploader :after-read="onIconRead" :before-delete="deleteIconRead" :disabled='disabled' type="file" accept="image/*" v-model="lconResourceList" max-count='1'>
            <van-icon class="uploader_icon" name="plus" />
          </van-uploader>
        </p>

        <p class="item">
          <span><span class="required">*</span>三农号名称</span>
          <van-cell-group>
            <van-field v-model="params.name" :disabled='disabled' name='name' placeholder="请填写三农号名称" :rules="[{ required: true,message:'三农号名称不能为空'}]" />
          </van-cell-group>
        </p>

        <p class="item">
          <span>地理坐标</span>
          <van-cell-group>
            <van-field v-model="params.location" placeholder="选择省、市、区/县" :disabled='disabled' @click="setShowPicker" />
          </van-cell-group>
        </p>

        <p class="item">
          <span>简介</span>
          <van-cell-group>
            <van-field v-model="params.introduction" type="textarea" placeholder="简单的介绍一下吧" :disabled='disabled' rows="1" autosize />
          </van-cell-group>
        </p>
      </div>

      <p class="explain">运营者信息</p>
      <div class="apply">
        <p class="item">
          <span>
            <span class="required">*</span>
            联系人姓名
            <van-icon name="eye" v-if='disabled' />
          </span>
          <van-cell-group>
            <van-field v-model="params.contactPeople" name='contactPeople' placeholder="请填写真实姓名" :disabled='disabled' :rules="[{ required: true,message:'姓名不能为空'}]" />
          </van-cell-group>
        </p>

        <p class="item">
          <span>
            <span class="required">*</span>
            手机号码
            <van-icon name="closed-eye" v-if='disabled' />
          </span>
          <van-cell-group>
            <van-field v-model="params.phone" placeholder="请填写手机号码" :disabled='disabled' name="phone" :rules="[{ required: true,message:'手机号不能为空' },{ pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '手机号格式错误' },]" />
          </van-cell-group>
        </p>

        <p class="item">
          <span>
            <span class="required">*</span>
            邮箱
            <van-icon name="closed-eye" v-if='disabled' />
          </span>
          <van-cell-group>
            <van-field v-model="params.email" name='email' placeholder="请填写邮箱地址" :disabled='disabled' :rules="[{ required: true,message:'邮箱不能为空' },{ validator:validatorEmail, message: '邮箱地址格式错误' }]" />
          </van-cell-group>
        </p>

        <p class="item">
          <span class="label">
            <span class="required">*</span>
            联系人身份证或统一社会信用代码
            <van-icon name="closed-eye" v-if='disabled' />
          </span>
          <van-cell-group>
            <van-field v-model="params.cardId" placeholder="请填写证件号码" :disabled='disabled' name='cardId' :rules="[{ required: true,message:'联系人身份证或者机构代码不能为空'}]" />
          </van-cell-group>
        </p>

        <p class="item">
          <span>
            <span class="required">*</span>
            资质证明（最多上传3张图片）
            <span class="explain1">个人账号请上传身份证及本人手持身份证照片</span>
            <span class="explain1">非个人账号请上传统一社会信用代码证书照片</span>
          </span>
          <van-uploader :after-read="onCardUrlsRead" :before-delete="deleteCardUrlsRead" :disabled='disabled' type="file" accept="image/*"  max-count='3' multiple v-model="cardList">
            <van-icon class="uploader_icon" name="plus" />
          </van-uploader>
        </p>

        <p class="item">
          <span>备注</span>
          <van-cell-group>
            <van-field v-model="params.remark" type="textarea" placeholder="请填写备注" rows="1" autosize />
          </van-cell-group>
        </p>

        <p class="item item2" v-if='params.auditMessage&&(state==2||state==3)'>
          <span>驳回意见：</span>
          <span>{{params.auditMessage}}</span>
        </p>
      </div>

      <img :src="require('@/assets/images/selfMedia/tips_progress.png')" alt="" v-if='state==0' class="state">
      <img :src="require('@/assets/images/selfMedia/tips_pass.png')" alt="" v-else-if='state==1' class="state">
      <img :src="require('@/assets/images/selfMedia/tips_reject.png')" alt="" v-else-if='state==2' class="state">
    </van-form>

    <p class="submit" @click="onSubmit" v-if='state==null||state==3'>提交申请</p>
    <p class="backStep" @click="backStep" v-if='state==null'>上一步</p>
    <p v-if='state==2' class="reject_btn">
      <span class="modification" @click="modification">修改</span>
      <span class="delete" @click="deleteApply">删除</span>
    </p>
    
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="areaList" value-key="name" @cancel="showPicker = false" @confirm="onSingleSelectConfirm" />
    </van-popup>
    

    <van-popup v-model="showCategoryPicker" round position="bottom">
      <van-picker show-toolbar :columns="mediaCategoryTree" value-key="name" @cancel="showCategoryPicker = false" @confirm="onCategorySelectConfirm" />
    </van-popup>

  </div>
</template>

<script>
import HeaderVue from "./components/HeaderVue.vue"
import selfMediaApi from "@/api/apis/selfMedia.js"
import UploadServer from "@/api/apis/upload.js";
import { wechatShare } from "@/utils";
export default {
  components: { HeaderVue },
  data(){
    return{
      params:{
        id:'',
        cardId:'',//证件号
        cardUrls:'',	//资质证明URL地址
        categoryId:'',//媒体号分类ID
        categoryName:'',//媒体号分类名称
        contactPeople:'',//联系人
        email:'',	//联系人邮箱
        introduction:'',//	简介
        lconResourceId:0,//	三农号图标id
        location:'',	//位置，省市区县 空隔区分
        name:'',//	三农号名称
        phone:'',//	联系人手机
        remark:'',//	申请人备注信息
      },
      recordParams:{},//记录原始数据
      showPicker:false,
      showCategoryPicker:false,
      lconResourceList:[],//三农号图标回显
      cardList:[],//资质证明回显
      state:null,//详情时的状态 0审核中，1通过，2驳回，3修改申请
      detail:{},//详情
      mediaCategoryTree:[],//媒体号分类数据
      areaList:[],//省市数据
      disabled:false,
    }
  },
  methods:{
    // 邮箱校验此处使用函数校验
    validatorEmail(val) {
      if(val){
        return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val);
      }else{
        return true
      }
    },
    goAnchor(id) { //设置滚动条到指定位置
      var anchor = document.getElementById(id);
      document.getElementById('apply_for_occupancy').scrollTop = anchor.offsetTop;
    },
    // 选择分类
    setShowCategoryPicker(){
      if(this.disabled) return
      this.showCategoryPicker=true
    },
    // 获取媒体号分类
    getSelfmediaCategoryTreeForApply(){
      selfMediaApi.getSelfmediaCategoryTreeForApply().then(res=>{
        if(res.code=='200'){
          res.data.list=res.data.list.filter(d=>d.name!='自媒体')
          this.mediaCategoryTree=res.data.list

          function setCategoryTree(data){
            data.forEach(item=>{
              item.children=item.childs||[{name:''}]
              item.text=item.name
              if(item.childs&&item.childs.length){
                setCategoryTree(item.childs)
              }
            })
          }
          setCategoryTree(this.mediaCategoryTree)
        }
      })
    },
    // 上传三农号图标
    onIconRead(file){
      console.log('file',file)
      this.uploadPic(file ).then(data=>{
        this.params.lconResourceId=data.resourceId

      })
    },
    // 删除三农号图标回调
    deleteIconRead(file,data){
      if(this.disabled) return
      let index=data.index
      this.lconResourceList.splice(index,1)

      this.params.lconResourceId=''
    },
    /* 上传图片 */
    uploadPic(file) {
      return new Promise((resolve,reject)=>{
        UploadServer.fetchUploadPic(
          file.file,
          function (percentage) {
            file.message = percentage;
          },
          function (res) {
            if (res.suc == 1) {
              resolve(res)
            } else {
              file.status = "failed";
              file.message = "上传失败";
            }
          }
        );
      })
    },
    setShowPicker(){
      if(this.disabled) return
      this.showPicker=!this.showPicker
    },
    /* 下拉选择省市地址 点击确认 */
    onSingleSelectConfirm(value) {
      this.params.location=value.join(' ')
      this.showPicker = false
    },
    // 下拉选择分类
    onCategorySelectConfirm(nameData,indexData){
      nameData=nameData.filter(d=>d)

      let activeData=JSON.parse(JSON.stringify(this.mediaCategoryTree))
      nameData.forEach((name,i)=>{
        activeData=activeData.filter(d=>d.name==name)
        if(activeData[0].children&&activeData[0].children[0].name){
          activeData=activeData[0].children
        }
      })
      
      this.params.categoryId=activeData[0].id
      this.params.categoryName=activeData[0].name
      this.showCategoryPicker=false
    },
    // 上一步
    backStep(){
      this.$router.push({path:'/SelectionClassify',query: {client:1}})
    },
    // 提交申请
    onSubmit(state){
      this.$refs.formData.validate().then(()=>{
        if(!this.params.lconResourceId){
          this.$toast({
            message: '请上传三农号图标',
            position: "center",
          });
          return
        }else if(!this.params.cardUrls){
          this.$toast({
            message: '请上传资质证明',
            position: "center",
          });
          return
        }

        if(this.params.id){//修改
          Promise.all([this.updateApply(),this.backForSubmit()]).then(data=>{
            this.$toast({
              message: '提交成功',
              position: "center",
            });
            this.$router.push({path:'/application_list',query: {client:1}})
          })

        }else{ // 新建
          this.addApply().then(res=>{
            this.$toast({
              message: '提交成功',
              position: "center",
            });
            this.$router.push({path:'/application_list',query: {client:1}})
          })
        }
      }).catch((errData)=>{
        let item=errData[0]
        this.$toast({
          message: item.message,
          position: "center",
        });
      })
    },
    updateApply(){// 修改申请
      return new Promise((resolve,reject)=>{
        selfMediaApi.updateApplyForSelfMediaFreChannel(JSON.stringify(this.params)).then(res=>{
          if(res.code==200){
            resolve()
          }
        })
      })
    },
    addApply(){// 新建申请
      return new Promise((resolve,reject)=>{
        selfMediaApi.addApplyForSelfMediaFreChannel(JSON.stringify(this.params)).then(res=>{
          if(res.code==200){
            resolve()
          }
        })
      })
    },
    // 驳回修改重新提交申请
    backForSubmit(){
      return new Promise((resolve,reject)=>{
        if(this.state!=3){
          resolve()
          return
        }
        selfMediaApi.backForSubmit({ id:this.params.id }).then(res=>{
          if(res.code==200){
            resolve()
          }
        })
      })
    },

    // 获取省市地址
    getTotalAmcAreaList(){
      selfMediaApi.getTotalAmcAreaList().then((res)=>{
        if(res.suc==1){
          this.areaList=res.datas
        }
      })
    },
    // 上传资质证明回调
    onCardUrlsRead(file){
      let cardUrlArr= this.params.cardUrls.split(',')
      cardUrlArr=cardUrlArr.filter(d=>d)
      if(file instanceof Array){
        file.forEach(d=>{
          this.uploadPic(d).then(data=>{
            cardUrlArr.push(data.url)
            this.params.cardUrls=cardUrlArr.join(',')
          })
        })
      }else{
        this.uploadPic(file).then(data=>{
          cardUrlArr.push(data.url)
          this.params.cardUrls=cardUrlArr.join(',')
        })
      }

    },
    // 删除资质回调
    deleteCardUrlsRead(file,data){

      if(this.disabled) return
      let index=data.index
      let cardUrlArr=this.params.cardUrls.split(',')
      this.cardList.splice(index,1)
      cardUrlArr.splice(index,1)

      this.params.cardUrls=cardUrlArr.join(',')
    },
    // 删除申请
    deleteApply(){
      this.$dialog.confirm({
        message: '是否确认删除',
      }).then(()=>{
        selfMediaApi.delApplyForSelfMediaFreChannel({id:this.params.id}).then((res)=>{
          if(res.code==200){
            this.$router.push({path:'/application_list',query: {client:1}})
          }
        })
      })
      return
    },
    // 修改申请
    modification(){
      this.disabled=false
      this.state=3

      this.params.phone=this.recordParams.phone
      this.params.cardId=this.recordParams.cardId
      this.params.email=this.recordParams.email
    },
    // 字符串替换成*
    strReplace(str){
      let newStr=''
      for(let i=0;i<str.length;i++){
        newStr+='*'
      }
      return newStr
    }

  },
  mounted(){

    this.goAnchor('title')
    let query = this.$route.query
    console.log(query)
    if(query){
      this.params.categoryName=query.activeName
      this.params.categoryId=query.activeId
    }

    if(query.id){
      this.params.id=query.id
    }
    if(query.state){
      this.state=query.state

      this.params=JSON.parse(sessionStorage.SelfMediaInfo)

      if(this.params.cardUrls){
        let cardUrlArr=this.params.cardUrls.split(',')
        cardUrlArr.forEach(url=>{
          this.cardList.push({
            url,
          })
        })
      }

      if(this.params.lconResourceUrl){
        let cardUrlArr=this.params.lconResourceUrl.split(',')
        cardUrlArr.forEach(url=>{
          this.lconResourceList.push({
            url,
          })
        })
      }

      if(this.params.phone){
        this.recordParams.phone=this.params.phone
        let newTest=this.params.phone.slice(0,3)
        let length=this.params.phone.length

        newTest+=this.strReplace(this.params.phone.slice(3,length))
      
        this.params.phone=newTest
      }
      if(this.params.cardId){
        this.recordParams.cardId=this.params.cardId
        let newTest=this.params.cardId.slice(0,3)
        let length=this.params.cardId.length

        newTest+=this.strReplace(this.params.cardId.slice(3,length))
      
        this.params.cardId=newTest
      }
      if(this.params.email){
        this.recordParams.email=this.params.email
        let newTest=this.params.email.slice(0,1)
        var resu = this.params.email.split('@')

        var name = resu[0]
        newTest+=this.strReplace(name.slice(1,name.length))
        newTest+='@'

        var host = resu[1]
        let index=host.lastIndexOf('.')
        var host1 = host.slice(0,index)
        newTest+=this.strReplace(host1)
        newTest+=host.slice(index)
        this.params.email=newTest
      }
      this.disabled=true

    }
    this.getTotalAmcAreaList()
    this.getSelfmediaCategoryTreeForApply()
    wechatShare('https://newapp2.farmer.com.cn/share/#/SelectionClassify?tencentShare=1',"媒体号入驻")
  }

}
</script>

<style lang='scss' scoped>
#apply_for_occupancy{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  .formData{
    position: relative;
    .state{
      position: absolute;
      top: 75px;
      left: 50%;
      transform: translateX(-50%);
      width: 75px;
    }
  }
  .title{
    text-align: center;
    padding: 5px 0 20px 0;
  }
  .required{
    margin-left: 5px;
    color: red;
  }
  .explain1{
    color: #ccc;
    font-size: 12px;
    display: block;
  }
  .apply{
    padding: 0 20px;
  }
  .explain{
    background: #eee;
    color: #a6a6a6;
    height: 30px;
    line-height: 30px;
    padding-left: 20px;
  }
  .item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    &.item2{
      justify-content: flex-start;
      border: none;
    }
    .label{
      width: 110px;
    }
    .uploader_icon{
      width: 50px;
      height: 50px;
      background: #eee;
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
      color: #ccc;
      font-size: 30px;
    }
    /deep/.van-uploader__preview-image {
        display: block;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
    }
    /deep/.van-uploader__wrapper{
      flex-wrap: nowrap;
    }
    .van-cell{
      padding: 0;
      /deep/.van-field__control{
        text-align: right;
      }
      /deep/.van-field__error-message{
        text-align: right;
      }
      /deep/.van-field__control:disabled{
        color: #323233;
        -webkit-text-fill-color:#323233;
      }
      /deep/input::-webkit-input-placeholder{
        color: #c8c9cc;
        -webkit-text-fill-color:#c8c9cc;
      }
    }
  }
  .data{
    text-align: right;
    flex: 1;
    min-height: 20px;
    margin-left: 20px;
  }
  /deep/.van-cell::after{
    border:0 !important;
    border-bottom:0;
  }
  .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
    border-width:0;
  }





  .submit{
    background: red;
    color: #fff;
    width: 90px;
    padding: 5px 0;
    border-radius: 15px;
    margin: 20px auto;
    text-align: center;
  }
  .backStep{
    color: red;
    margin: 20px;
    text-align: center;
    font-size: 18px;
  }
  .reject_btn{
    margin: 20px 0;
    display: flex;
    justify-content: space-evenly;
    span{
      padding: 5px 35px;
      border-radius: 50px;
    }
    .modification{
      background-color: #0099ff;
      color: #fff;
    }
    .delete{
      border: 1px solid #ccc;
    }
  }
}
</style>